/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer } from './WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer';
import {
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerFromJSON,
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerFromJSONTyped,
    WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerToJSON,
} from './WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer';

/**
 * CreateReply dto
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto
 */
export interface WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto
     */
    eventId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto
     */
    inviteId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto
     */
    replyId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto
     */
    answer?: string | null;
    /**
     * 
     * @type {Array<WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer>}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto
     */
    timeAnswers?: Array<WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswer> | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto
     */
    authCode?: string | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto {
    return WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'inviteId': !exists(json, 'inviteId') ? undefined : json['inviteId'],
        'replyId': !exists(json, 'replyId') ? undefined : json['replyId'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'answer': !exists(json, 'answer') ? undefined : json['answer'],
        'timeAnswers': !exists(json, 'timeAnswers') ? undefined : (json['timeAnswers'] === null ? null : (json['timeAnswers'] as Array<any>).map(WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerFromJSON)),
        'authCode': !exists(json, 'authCode') ? undefined : json['authCode'],
    };
}

export function WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServiceUpdateReplyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'eventId': value.eventId,
        'inviteId': value.inviteId,
        'replyId': value.replyId,
        'email': value.email,
        'answer': value.answer,
        'timeAnswers': value.timeAnswers === undefined ? undefined : (value.timeAnswers === null ? null : (value.timeAnswers as Array<any>).map(WebApiServicesDataTransferObjectsReplyServiceCreateReplyTimeAnswerToJSON)),
        'authCode': value.authCode,
    };
}

